export default __webpack_public_path__ + "static/media/alihealthmgr-hover.2b4ab786.svg";